import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons";

function ErrorModal(props) {
    const { show, onHide, errorText } = props;

    return (
        <>
            <Modal show={show} onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <>
                            <i className="mr-5"><FontAwesomeIcon icon={faLightbulb} /></i> Ошибка
                        </>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="alert alert-danger fs-5" role="alert">
                        {errorText}
                    </div>

                </Modal.Body>

            </Modal>
        </>
    );
}
export default ErrorModal;
